module.exports = __webpack_public_path__ + "img/yangDetail3.8923b7f0.jpg";